import React, { useState } from 'react';
import styles from './index.module.scss';
import ChipList from '@components-clean/core/chip-list';
import { useTranslation } from '@hooks/index';
import { ModuleNames } from '@utils/constants';

export type SMSelectedReviewSectionTab = 'summary' | 'subject' | 'activity' | 'notes';

type SMSelectedReviewSectionTabDefinition = {
    /* For getting translated label */
    translationKey: string;
    value: SMSelectedReviewSectionTab;
};

const tabs: SMSelectedReviewSectionTabDefinition[] = [
    {
        translationKey: 'tabs.summary.title',
        value: 'summary',
    },
    {
        translationKey: 'tabs.subject.title',
        value: 'subject',
    },
    {
        translationKey: 'tabs.activity.title',
        value: 'activity',
    },
    {
        translationKey: 'tabs.notes.title',
        value: 'notes',
    },
] as const;

type Props = {
    reviewRecordId: number;
    selectedTab: SMSelectedReviewSectionTab;
    setSelectedTab: React.Dispatch<React.SetStateAction<SMSelectedReviewSectionTab>>;
};

const SMSelectedReviewSectionActionBar = ({ reviewRecordId, selectedTab, setSelectedTab }: Props) => {
    const { t } = useTranslation('sm', {
        keyPrefix: 'sm:monitoringToolkit.manageReviewsGrid.selectedReviewSection',
    });

    // *** Remove if/when KendoUI fix this bug ***
    // Due to a KendoUI bug, when the ChipList rerenders, the last clicked Chip focuses itself...
    // To get around this, we change the key when the tab changes, so that a fresh ChipList is rendered (with no last clicked Chip)
    const [key, setKey] = useState(0);

    return (
        <div className={styles.actionBar}>
            <div className={styles.titleContainer}>
                {t('recordId')}: {`${ModuleNames.CM}-${reviewRecordId}`}
            </div>
            <ChipList
                key={key}
                data-testid="sm-selected-review-tabs"
                className={styles.tabsContainer}
                value={selectedTab}
                onChange={async (e) => {
                    setKey((k) => k + 1);

                    // If already-selected tab clicked, do nothing...
                    const newTab = e.value as SMSelectedReviewSectionTab | null;
                    if (newTab == null || newTab === selectedTab) {
                        return;
                    }

                    setSelectedTab(newTab);
                }}
                data={tabs.map((tab) => ({
                    text: t(tab.translationKey),
                    value: tab.value,
                }))}
            />
        </div>
    );
};

export default SMSelectedReviewSectionActionBar;
